import './style.css'
import {ReactTyped} from "react-typed";
import { isMobile } from 'react-device-detect';

export const HomePage = () => {

    return (
            <div className={`homepageblock mx-2 ${isMobile ? 'homepageblock-mobile' : ''}`}>
                <h1>
                    {isMobile ?
                        <>
                            Ogarniaj posiłki
                            <br/>
                            w swojej placówce{" "}
                            <br/>
                        </>
                        :
                        <>
                            Ogarniaj posiłki w swojej placówce{" "}
                        </>
                    }
                    <ReactTyped
                        strings={["łatwo",
                            "szybko",
                            "automatycznie",
                            "kompleksowo"]}
                        typeSpeed={100}
                        loop
                        backSpeed={20}
                        cursorChar=">"
                        showCursor={true}
                    />
                </h1>
            </div>
    )
}